export default __webpack_public_path__ + "static/media/mainPoster.6fa48b5c.jpg";